import React from 'react';
import {
    NumberField,
    BooleanField,
    SelectField,
    EditButton,
} from 'react-admin';
import Divider from '@material-ui/core/Divider';

import SectionTitle from '../components/SectionTitle';
import { esTipoTope, isProductiveRule } from './regla-utils';

import { TIPOS_CONDICION_TOPE } from '../../enum/tipo-condicion-enum';
import { TIPOS_INTERVALO_TOPE } from '../../enum/tipo-intervalor-enum';

import ReferenceFields from '../../libs/sgx/components/ReferenceFields';

const ReglaConfiguracionDeTope = ({link, ...props}) => esTipoTope(props.record.idTipoRegla) && (
    <React.Fragment>
        <SectionTitle label="resources.tope.title" />
        {link === 'edit' && !isProductiveRule(props) && <EditButton resource="tope" basePath="/tope" record={props.record}/>}
        <ReferenceFields {...props} reference="tope">
            <NumberField source="valor" />
            <SelectField
                source="tipoCondicion"
                optionText="description"
                optionValue="id"
                choices={TIPOS_CONDICION_TOPE}
            />
            <SelectField
                source="tipoIntervalo"
                optionText="description"
                optionValue="id"
                choices={TIPOS_INTERVALO_TOPE}
            />
            <NumberField source="cantidadDias" />
            <BooleanField source="porDiagnostico" />
            <BooleanField source="porGrupoPrestacion" />
            <BooleanField source="porPrestadorEfector" />
            <BooleanField source="porEntidadEfectora" />
        </ReferenceFields>
        <Divider />
    </React.Fragment>
);

export default ReglaConfiguracionDeTope;
